import React from 'react';

const COLOR_KEYS = [
  'buttonBg',
  'buttonText',
  'buttonHover',
  'sidebarBg',
  'sidebarText',
  'headerBg',
  'headerText',
];

const ThemeCard = ({ theme, onSelect, selected }) => {
  const colors = theme?.Colors || {};
  return (
    <div
      onClick={() => onSelect && onSelect(theme)}
      className="theme-card-row"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
        padding: '8px 10px',
        marginBottom: 6,
        borderRadius: 6,
        cursor: 'pointer',
        background: selected ? 'rgba(28, 81, 94, 0.08)' : 'transparent',
        border: selected
          ? '1px solid #1c515e'
          : '1px solid transparent',
        transition: 'background 0.15s ease, border-color 0.15s ease',
      }}
      onMouseEnter={(e) => {
        if (!selected) e.currentTarget.style.background = '#f5f5f5';
      }}
      onMouseLeave={(e) => {
        if (!selected) e.currentTarget.style.background = 'transparent';
      }}
    >
      <span
        style={{
          fontSize: 13,
          fontWeight: selected ? 600 : 500,
          color: selected ? '#1c515e' : '#333',
          flex: 1,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        title={theme?.ThemeName}
      >
        {theme?.ThemeName}
      </span>
      <div style={{ display: 'flex', gap: 3 }}>
        {COLOR_KEYS.map((k) => (
          <div
            key={k}
            title={`${k}: ${colors[k] || ''}`}
            style={{
              width: 16,
              height: 16,
              background: colors[k] || '#fff',
              borderRadius: 3,
              border: '1px solid #ddd',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ThemeCard;
